import { BrokerExtensions } from "@primaria/plugins-core";
import { PrimariaApi } from "@uxland/primary-shell";
import "../../activity-history-item/filter/UI/activity-history-filters/activity-history-filters";
import { bootstrapSetCommonFilter, teardownSetCommonFilter } from "./common-filters/set-common-filter/bootstrapper";
import { bootstrapAddCustomFilter, teardownAddCustomFilter } from "./custom-filters/add-custom-filters/bootstrapper";
import {
  bootstrapSetCustomFilterAllValues,
  teardownSetCustomFilterAllValues,
} from "./custom-filters/set-custom-filter-all-values/bootstrapper";
import {
  bootstrapSetCustomFilterGroup,
  teardownSetCustomFilterGroup,
} from "./custom-filters/set-custom-filter-group/bootstrapper";
import {
  bootstrapSetCustomFilterValue,
  teardownSetCustomFilterValue,
} from "./custom-filters/set-custom-filter-value/bootstrapper";
import {
  bootstrapDeleteDiagnosticFilterValue,
  teardownDeleteDiagnosticFilterValue,
} from "./diagnostic-filters/delete/bootstrapper";
import { bootstrapSetDiagnosticFilter, teardownSetDiagnosticFilter } from "./diagnostic-filters/set/bootstrapper";
import { subscribeDiagnosticFilters } from "./diagnostic-filters/subscribe-diagnostic-historic-filters";
import { bootstrapResetFilters, teardownResetFilters } from "./reset/bootstrapper";
import { bootstrapAddUpFilter, teardownAddUpFilter } from "./up-filters/add/bootstrapper";
import { bootstrapSetUpFilter, teardownSetUpFilter } from "./up-filters/set/bootstrapper";

export const bootstrapFilters = (broker: BrokerExtensions, api: PrimariaApi) => {
  bootstrapSetCommonFilter(broker);
  bootstrapAddCustomFilter(broker);
  bootstrapSetCustomFilterGroup(broker);
  bootstrapSetCustomFilterValue(broker);
  bootstrapSetCustomFilterAllValues(broker);
  bootstrapSetDiagnosticFilter(broker);
  bootstrapDeleteDiagnosticFilterValue(broker);
  bootstrapAddUpFilter(broker);
  bootstrapSetUpFilter(broker);
  bootstrapResetFilters(broker);
  subscribeDiagnosticFilters(api);
};

export const teardownFilters = () => {
  teardownSetCommonFilter();
  teardownAddCustomFilter();
  teardownSetCustomFilterGroup();
  teardownSetCustomFilterValue();
  teardownSetCustomFilterAllValues();
  teardownSetDiagnosticFilter();
  teardownDeleteDiagnosticFilterValue();
  teardownAddUpFilter();
  teardownSetUpFilter();
  teardownResetFilters();
};
